/**
 * @since 8.2.0
 */
export interface UpdateRemindersListResult {
  /**
   * Identifier of the updated reminders list.
   *
   * @platform iOS
   * @since 8.2.0
   */
  id: string;
}
